<div class="page">
  <div class="page__container" #page>
    <h1 *ngIf="this.resellerProfileToEdit" class="page__title h2 mb-5">{{ 'reseller_profiles_edit_title' | translate }}</h1>
    <h1 *ngIf="!this.resellerProfileToEdit" class="page__title h2 mb-5">{{ 'reseller_profile_title' | translate }}</h1>

    <div class="page__form-wrap">
      <form [formGroup]="editForm">
        <div class="form-group row">
          <label for="profile_name" class="col-sm-4" translate>reseller_profiles_create_name</label>
          <div class="col-sm-8">
            <input type="text" id="profile_name" formControlName="name" name="profile_name" class="form-control" />
            <wsb-validation-error-msg [fc]="editForm.get('name')"></wsb-validation-error-msg>
          </div>
        </div>

        <div class="form-group row">
          <label class=" col-sm-4" translate>reseller_profiles_table_services</label>
          <div class="d-flex flex-wrap  col-sm-8">
            <div class="d-flex ps-0 mb-2 col-md-12" *ngFor="let item of services">
              <wsb-ui-checkbox
                [disabled]="item.name === 'sms'"
                [checkboxId]="item.name"
                [(checked)]="item.enabled"
                (change)="onChangeEvent($event)"
                class="me-1 pt-1"
              ></wsb-ui-checkbox>
              <span>{{ 'reseller_profiles_table_' + item.name | translate }}</span>
            </div>
          </div>
        </div>

        <div class="form-group row" *ngIf="this.credits.length > 1">
          <label class=" col-sm-4" translate>reseller_profiles_table_types</label>
          <div class="d-flex flex-wrap  col-sm-8">
            <div class="d-flex ps-0 mb-2 col-md-12" *ngFor="let item of credits">
              <wsb-ui-checkbox
                [checkboxId]="item.title"
                [(checked)]="item.enabled"
                (change)="onChangeEvent($event)"
                class="me-1 pt-1"
              ></wsb-ui-checkbox>
              <span>{{ item.title | translate }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class=" col-sm-4" translate>sharing_group_option</label>
          <div class="d-flex flex-wrap col-sm-8">
            <label class="radio-custom">
              <input
                type="radio"
                name="sharingGroup"
                id="sharingGroup_no"
                [(ngModel)]="sharingGroup"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onChangeEvent($event)"
                [value]="false"
              />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>common_no</span>
            </label>
            <label class="radio-custom ms-2">
              <input
                type="radio"
                name="sharingGroup"
                id="sharingGroup_yes"
                [(ngModel)]="sharingGroup"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onChangeEvent($event)"
                [value]="true"
              />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>common_yes</span>
            </label>
          </div>
        </div>
        <div class="form-group row">
          <div *ngIf="sharingGroup" class="col-sm-8 offset-sm-4 d-flex flex-column">
            <!-- <div class="p-3 mb-2 alert alert-primary" [innerHTML]="'alert_sharing_group' | translate" ></div> -->
            <ng-select
              (change)="changed($event)"
              [items]="sharingGroupBuffer"
              bindLabel="name"
              [clearable]="false"
              clearAllText
              multiple="true"
              [virtualScroll]="true"
              formControlName="sharedGroups"
              class="form-control"
              (scroll)="onScrollSharingGroup($event)"
              (scrollToEnd)="onScrollToEndSharingGroup()"
            >
            </ng-select>
          </div>
        </div>
        <div class="form-group row">
          <label class=" col-sm-4" translate>sharing_templates_option</label>
          <div class="d-flex flex-wrap col-sm-8">
            <label class="radio-custom">
              <input
                type="radio"
                name="sharingTemplate"
                id="sharingTemplate_no"
                [(ngModel)]="sharingTemplate"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onChangeEvent($event)"
                [value]="false"
              />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>common_no</span>
            </label>
            <label class="radio-custom ms-2">
              <input
                type="radio"
                name="sharingTemplate"
                id="sharingTemplate_yes"
                [(ngModel)]="sharingTemplate"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onChangeEvent($event)"
                [value]="true"
              />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>common_yes</span>
            </label>
          </div>
        </div>
        <div class="form-group row">
          <div *ngIf="sharingTemplate" class="col-sm-8 offset-sm-4 d-flex flex-column">
            <ng-select
              (change)="changed($event)"
              [items]="templateList"
              bindLabel="name"
              [clearable]="false"
              clearAllText
              multiple="true"
              formControlName="sharedTemplates"
              class="form-control"
            >
            </ng-select>
          </div>
        </div>
        <div class="form-group row">
          <label class=" col-sm-4" translate>sharing_blacklist_option</label>
          <div class="d-flex flex-wrap col-sm-8">
            <label class="radio-custom">
              <input
                type="radio"
                name="sharingBlacklist"
                id="sharingBlacklist_no"
                [(ngModel)]="sharingBlacklist"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onChangeEvent($event)"
                [value]="false"
              />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>common_no</span>
            </label>
            <label class="radio-custom ms-2">
              <input
                type="radio"
                name="sharingBlacklist"
                id="sharingBlacklist_yes"
                [(ngModel)]="sharingBlacklist"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onChangeEvent($event)"
                [value]="true"
              />
              <span class="radio-custom__radio"></span>
              <span class="radio-custom__label" translate>common_yes</span>
            </label>
          </div>
        </div>
      </form>
    </div>
    <div class="page__actions actions-bar" #actionsBar style="z-index: 1">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex">
          <button
            #submitBtn
            class="btn  btn-primary   btn-sm"
            [disabled]="editForm.pristine || editForm.invalid"
            (click)="submitForm()"
            translate
          >
            common_save
          </button>
          <button #submitBtn (click)="goBack()" class="btn  btn-secondary ms-3  btn-sm" translate>common_back</button>
          <button *ngIf="editForm.dirty" type="button" class="btn btn-link btn-sm ms-2" (click)="resetForm()" translate>
            common_cancel
          </button>
        </div>
        <div *ngIf="!editForm.pristine" class="mt-2">
          <small translate>common_unsaved_changes</small>
        </div>
      </div>
    </div>
  </div>
</div>
